import { useMutation, type MutationKey } from "react-query";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";

type DeleteFleetAttachmentPayload = {
  vehicleId: number;
  attachmentId: number;
};

/**
 * Delete a fleet attachment (DELETE /fleet/vehicles/:id/attachments/:attachmentId).
 */
export function useRemoteDeleteFleetAttachment() {
  const { t } = useTranslation();
  const snackbar = useSnackbar();

  return useMutation<void, RemoteApiError, DeleteFleetAttachmentPayload>(
    ["fleet", "delete-attachment"] as MutationKey,
    async ({ vehicleId, attachmentId }: DeleteFleetAttachmentPayload): Promise<void> => {
      try {
        await Axios.delete(`/fleet/vehicles/${vehicleId}/attachments/${attachmentId}`);
        snackbar.enqueueSnackbar(t("Successfully deleted attachment"), { variant: "success" });
      } catch (error) {
        snackbar.enqueueSnackbar(t("Failed to delete attachment"), { variant: "error" });
        throw error;
      }
    }
  );
}
